var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{appPhone: _vm.isPhone},style:({'min-width': _vm.isPhone ? 'auto': '1200px'}),attrs:{"id":"app"}},[_c('Header',{attrs:{"tabIndex":_vm.index},on:{"jump":_vm.jump}}),_c('router-view'),_c('Footer',{on:{"jump":_vm.jump}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }